module.exports = __webpack_public_path__ + "img/section3Card1logo1.4dd6cacd.png";